import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { chatHistory } from '../../../digital-assistant.model';
import { DigitalAssistantService } from '../../../digital-assistant.service';
import { signal } from '@angular/core';

@Component({
  selector: 'miq-chat-left-panel',
  template: `
    <!-- Left Panel -->

    <div class="left-panel">
      <div class="panel-content">
        <div class="panel-header">
          <div class="header-title">
            <mat-icon (click)="toggleLeftPanel()">arrow_back</mat-icon>
            <span class="chats-label">{{ 'chat.chats' | xTranslate }}</span>
          </div>
          <div>({{ chatHistory.length }})</div>
        </div>
        <hr />
        <div class="panel-body">
          <div class="new-chat">
            <button mat-button class="new-chat-button" (click)="newSession()">
              <mat-icon svgIcon="new-chat-v1"></mat-icon>
              <span>{{ 'chat.newChat' | xTranslate }}</span>
            </button>
          </div>
          <p class="chat-history-note">{{ 'chat.historyNote' | xTranslate }}</p>
          <div class="chat-history">
            <ng-container *ngIf="chatHistory.length > 0">
              <ng-container *ngFor="let chat of chatHistory"
                ><!--to show latest on top-->
                <div class="chat-item-container" (click)="selectChat(chat)">
                  <div class="chat-item-title">
                    {{ chat.messages[0].content }}
                  </div>
                  <div class="chat-item-date">
                    {{ chat.messages[0].timestamp | date: 'MM/dd' }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./chat-left-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatLeftPanelComponent {
  @Output() emitNewSession = new EventEmitter<void>();
  @Output() emitSelectedSession = new EventEmitter<chatHistory>();

  private _chatHistory: chatHistory[] = [];

  @Input()
  get chatHistory(): chatHistory[] {
    return this._chatHistory;
  }

  set chatHistory(value: chatHistory[]) {
    this._chatHistory = value;
  }

  constructor(public chatBotService: DigitalAssistantService) {
    this.chatBotService.isLeftPanelOpen = signal(false); // Initialize isLeftPanelOpen as a signal
  }

  toggleLeftPanel() {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.chatBotService.trackUserAction('Chat history panel toggled');
  }

  newSession(): void {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.emitNewSession.emit();
  }

  selectChat(chat: chatHistory): void {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.emitSelectedSession.emit(chat);
    const actionDetailParams = {
      selectedHistory: {
        sessionId: chat.sessionId,
        historyTitle: chat.messages[0].content,
      },
    };
    this.chatBotService.trackUserAction('Chat selected from history', actionDetailParams);
  }
}
